export const AUTH_ERROR_CODES = [401, 422];
